// src/utils/axiosConfig.js
import axios from "axios";
import { authService } from "../services/authService";
import config from "../config/config";
import { handleError, shouldRetryError } from "./errorHandler";

// Configuración base
const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 10000, // 10 segundos de timeout
});

// Interceptor para requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(handleError(error));
  }
);

// Interceptor para responses
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Si el error debe reintentarse y no hemos excedido los reintentos
    if (shouldRetryError(error) && error.config && !error.config._retry) {
      error.config._retry = true;
      try {
        return await axiosInstance(error.config);
      } catch (retryError) {
        return Promise.reject(handleError(retryError));
      }
    }

    // Si es un error de autenticación, hacer logout
    if (error.response?.status === 401) {
      authService.logout();
      window.location = "/";
    }

    return Promise.reject(handleError(error));
  }
);

export default axiosInstance;
